import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectChangesToYourJourneySCTIStep = (state) => state.get('changesToYourJourneySCTIStep');

const makeSelectChangesToYourJourneySCTIStep = () => createSelector(
  selectChangesToYourJourneySCTIStep,
  (changesToYourJourneySCTIStepState) => ({
    haveYouCanceledOrChangedYourJourneyBeforeLeaving: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'haveYouCanceledOrChangedYourJourneyBeforeLeaving']),
      ''
    ),
    wereYouDelayedWhileTravelingToASpecialEvent: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'wereYouDelayedWhileTravelingToASpecialEvent']),
      ''
    ),
    didYouCancelOrChangeYourTravelPlansDueToARelevantPerson: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'didYouCancelOrChangeYourTravelPlansDueToARelevantPerson']),
      ''
    ),
    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition']),
      ''
    ),
    wereAnyOfYourTravelPlansOrganisedByATravelAgent: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'wereAnyOfYourTravelPlansOrganisedByATravelAgent']),
      ''
    ),
    wereYouChargedACancellationFeeByTheTravelAgent: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'wereYouChargedACancellationFeeByTheTravelAgent']),
      ''
    ),


    haveYouChangedYourJourneyAfterLeaving: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'haveYouChangedYourJourneyAfterLeaving']),
      ''
    ),

    wereYouDelayedWhileTravelingToASpecialEventAL: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'wereYouDelayedWhileTravelingToASpecialEventAL']),
      ''
    ),

    didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL']),
      ''
    ),

    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL']),
      ''
    ),

    nameOfRelevantPerson: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'nameOfRelevantPerson']),
      ''
    ),

    dateOfBirthOfRelevantPerson: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'dateOfBirthOfRelevantPerson']),
      ''
    ),

    relationshipWithRelevantPerson: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'relationshipWithRelevantPerson']),
      ''
    ),

    nameOfRelevantPersonAL: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'nameOfRelevantPersonAL']),
      ''
    ),

    dateOfBirthOfRelevantPersonAL: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'dateOfBirthOfRelevantPersonAL']),
      ''
    ),

    relationshipWithRelevantPersonAL: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'relationshipWithRelevantPersonAL']),
      ''
    ),

    whatExpensesAreYouClaimingFor: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      ''
    ),

    didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption']),
      ''
    ),

    wereAnyOfYourTravelPlansOrganisedByATravelAgentPI: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'wereAnyOfYourTravelPlansOrganisedByATravelAgentPI']),
      ''
    ),

    wereYouChargedACancellationFeeByTheTravelAgentPI: mapWithDefault(
      changesToYourJourneySCTIStepState,
      () => changesToYourJourneySCTIStepState.getIn(['form', 'wereYouChargedACancellationFeeByTheTravelAgentPI']),
      ''
    ),

    changesToYourJourneyBeforeLeavingExpenseItems1: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems1']) && changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems1']).toJS(), ''),
    changesToYourJourneyBeforeLeavingExpenseItems2: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems2']) && changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems2']).toJS(), ''),
    changesToYourJourneyBeforeLeavingExpenseItems3: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems3']) && changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems3']).toJS(), ''),
    changesToYourJourneyBeforeLeavingExpenseItems4: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4']) && changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4']).toJS(), ''),
    changesToYourJourneyBeforeLeavingExpenseItems4PI: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4PI']) && changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4PI']).toJS(), ''),
    changesToYourJourneyAfterLeavingExpenseItems1: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems1']) && changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems1']).toJS(), ''),
    changesToYourJourneyAfterLeavingExpenseItems2: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems2']) && changesToYourJourneySCTIStepState.getIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems2']).toJS(), ''),
    cuttingYourTripShortToReturnHomeExpenseItems: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'cuttingYourTripShortToReturnHomeExpenseItems']) && changesToYourJourneySCTIStepState.getIn(['form', 'cuttingYourTripShortToReturnHomeExpenseItems']).toJS(), ''),
    travelInterruptionExpenseItems: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'travelInterruptionExpenseItems']) && changesToYourJourneySCTIStepState.getIn(['form', 'travelInterruptionExpenseItems']).toJS(), ''),
    resumingYourTripBackOverseasItems: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'resumingYourTripBackOverseasItems']) && changesToYourJourneySCTIStepState.getIn(['form', 'resumingYourTripBackOverseasItems']).toJS(), ''),
    petBoardingFacilityExpenseItems: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'petBoardingFacilityExpenseItems']) && changesToYourJourneySCTIStepState.getIn(['form', 'petBoardingFacilityExpenseItems']).toJS(), ''),
    childCareExpensesExpenseItems: mapWithDefault(changesToYourJourneySCTIStepState, () => changesToYourJourneySCTIStepState.getIn(['form', 'childCareExpensesExpenseItems']) && changesToYourJourneySCTIStepState.getIn(['form', 'childCareExpensesExpenseItems']).toJS(), ''),
  })
);

const makeSelectChangesToYourJourneySCTIStepErrors = () =>
  createSelector(selectChangesToYourJourneySCTIStep, (state) => state.get('errors'));

export {
  makeSelectChangesToYourJourneySCTIStep,
  makeSelectChangesToYourJourneySCTIStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.ChangesToYourJourney/selectors.js